import React, { useState, useEffect } from 'react'
import loc_img from "../../../assets/images/loc_img.png"
import phone_icon from "../../../assets/images/phone_icon.png"
import glob_icon from "../../../assets/images/glob_icon.png"
import address_icon from "../../../assets/images/address_icon.png"
import msg_icon from "../../../assets/images/msg_icon.png"
import schedule_clock from "../../../assets/images/schedule_clock.png"
import back_arrow from "../../../assets/images/back_arrow.png"
import up_arrow from "../../../assets/images/up_arrow.png"
import logo from "../../../assets/images/doctor.png";
import './doctor.css'
import { DoctorDescription } from './DoctorDescription'
import DoctorReview from './DoctorReview'
import ChatBox from "./ChatBox";
import history from '../../../common/history'
import full_star from '../../../assets/images/full-star.svg'
import { Spinner } from 'evergreen-ui';
import sm_star from '../../../assets/images/sm-star.png'
import Rating from 'react-rating'
import { useParams } from 'react-router'
import { withFirebase } from '../../../services'
import getDistanceMiles from '../../../common/distanceMiles'
import Review from '../../../components/Generic/Review'
import UserScheduleAppointmentPopup from "./UserScheduleAppointmentPopup";

const Doctor = (props) => {

    const { firebase } = props;

    const [currentTab, setCurrentTab] = useState("description")
    const [doctorDetails, setDoctorDetails] = useState(null)
    const [isLoading, setLoading] = useState(false)
    const [distance, setDistance] = useState(0)
    const [isImgLoding, setImgLoding] = useState(true);
    const [showPopup, setShowPopup] = useState(false);

    // 🔥 INMAIL STATES
    const [showInmailPopup, setShowInmailPopup] = useState(false);
    const [subject, setSubject] = useState("New Query");
    const [message, setMessage] = useState("");
    const [showInmailButton, setShowInmailButton] = useState(false);

    let { id } = useParams();

    useEffect(() => {
        if (id) {
            getDoctorDetails(id)
        }
    }, [id])

    const getDoctorDetails = async (id) => {
        setLoading(true)

        const result = await firebase.db
            .collection("healthCareProfessionals")
            .doc(id)
            .get();

        if (result.exists) {
            const Physician = result.data();

            setDoctorDetails(Physician);

            // 🔥 SHOW BUTTON ONLY FOR PREMIUM / CORE
            const sub = Physician?.subscription?.toLowerCase?.() || "";

            if (sub === "premium" || sub === "core") {
                setShowInmailButton(true);
            } else {
                setShowInmailButton(false);
            }

            getUserLocation(
                Physician.location.latitude,
                Physician.location.longitude
            )
        }

        setLoading(false)
    }

    const getUserLocation = async (lat, lng) => {
        navigator.geolocation.getCurrentPosition(
            position => setUserLocationData(position, lat, lng),
            err => console.log(err)
        );
    }

    const setUserLocationData = async (position, lat, lng) => {

        const providerLocation = {
            latitude: lat,
            longitude: lng
        }

        const userLocation = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
        }

        const distanceMeters = await getDistanceMiles(
            providerLocation,
            userLocation
        )

        setDistance(distanceMeters)
    }

    const switchTab = (currentTab) => {
        switch (currentTab) {
            case "description":
                return <DoctorDescription data={doctorDetails} />

            case "review":
                return <DoctorReview data={doctorDetails} docID={id} />

            case "chat":
                return <ChatBox data={doctorDetails} docID={id} />

            default:
                return <p>Data loaded ✅</p>;
        }
    };

    const changeTab = (name) => {
        setCurrentTab(name)
    }

    const clearMessageBody = () => { setMessage(""); };
    // 🔥 SEND INMAIL
    const sendInmail = async () => {
        try {

            const userEmail = firebase.auth.currentUser.email;
            const providerEmail = doctorDetails?.email;

            if (!userEmail || !providerEmail) return;

            const existing = await firebase.db
                .collection("inmail")
                .where("userId", "==", userEmail)
                .where("providerId", "==", providerEmail)
                .get();

            let conversationId = "";

            if (!existing.empty) {
                conversationId = existing.docs[0].id;
            } else {

                const welcomeText =
                    "Healthcare is better when we work together. Use InMail to connect with providers, discuss referrals, share expertise, and build meaningful professional relationships.";

                const docRef = await firebase.db
                    .collection("inmail")
                    .add({
                        userId: userEmail,
                        providerId: providerEmail,
                        subject: subject,
                        createdAt: new Date(),
                        lastMessage: welcomeText,
                        lastMessageAt: new Date(),
                        unreadCountUser: 1,
                        unreadCountProvider: 0,
                    });

                conversationId = docRef.id;

                await firebase.db
                    .collection("inmail")
                    .doc(conversationId)
                    .collection("messages")
                    .add({
                        text: welcomeText,
                        senderId: providerEmail,
                        senderRole: "provider",
                        createdAt: new Date(),
                        readBy: [],
                    });
            }

            if (message.trim() !== "") {

                await firebase.db
                    .collection("inmail")
                    .doc(conversationId)
                    .collection("messages")
                    .add({
                        text: message,
                        senderId: userEmail,
                        senderRole: "user",
                        createdAt: new Date(),
                        readBy: [userEmail],
                    });

                await firebase.db
                    .collection("inmail")
                    .doc(conversationId)
                    .update({
                        subject: subject,
                        lastMessage: message,
                        lastMessageAt: new Date(),
                        unreadCountProvider:
                            firebase.firestore.FieldValue.increment(1),
                    });
            }

            setShowInmailPopup(false);
            setSubject("New Query");
            setMessage("");

            alert("InMail sent successfully.");

        } catch (error) {
            console.log(error);
            alert("Unable to send InMail.");
        }
    }

    return (
        <div className="doctor-container">

            {/* 🔥 INMAIL POPUP */}
{showInmailPopup && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "rgba(0,0,0,0.35)",
      zIndex: 99999,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "20px"
    }}
  >
    <div
      style={{
        width: "860px",
        maxWidth: "100%",
        background: "#ffffff",
        borderRadius: "12px",
        boxShadow: "0 20px 50px rgba(0,0,0,0.18)",
        overflow: "hidden",
        fontFamily: "Arial, Helvetica, sans-serif"
      }}
    >

      {/* HEADER */}
      <table
        style={{
          width: "100%",
          borderBottom: "1px solid #e8e8e8",
          borderCollapse: "collapse"
        }}
      >
        <tbody>
          <tr>
            <td
              style={{
                padding: "18px 22px",
                fontSize: "38px",
                fontWeight: "700",
                color: "#3b3b3b",
                textAlign: "left"
              }}
            >
              New InMail
            </td>

            <td
              style={{
                width: "70px",
                textAlign: "right",
                paddingRight: "18px"
              }}
            >
              <button
                onClick={() => setShowInmailPopup(false)}
                style={{
                  background: "transparent",
                  border: "none",
                  fontSize: "34px",
                  cursor: "pointer",
                  color: "#666"
                }}
              >
                ×
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      {/* TO ROW */}
      <table
        style={{
          width: "100%",
          borderBottom: "1px solid #ededed",
          borderCollapse: "collapse"
        }}
      >
        <tbody>
          <tr>
            <td
              style={{
                width: "70px",
                padding: "16px 22px",
                fontWeight: "700",
                fontSize: "18px",
                textAlign: "left"
              }}
            >
              To:
            </td>

            <td
              style={{
                width: "55px",
                padding: "12px 0px",
                textAlign: "left"
              }}
            >
              <img
                src={doctorDetails?.headshotURL || logo}
                alt=""
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  display: "block"
                }}
              />
            </td>

            <td
              style={{
                padding: "16px 0px",
                fontSize: "18px",
                color: "#555",
                textAlign: "left"
              }}
            >
              {doctorDetails?.name}
            </td>
          </tr>
        </tbody>
      </table>

      {/* SUBJECT */}
      <table
        style={{
          width: "100%",
          borderBottom: "1px solid #ededed",
          borderCollapse: "collapse"
        }}
      >
        <tbody>
          <tr>
            <td
              style={{
                width: "100px",
                padding: "18px 22px",
                fontWeight: "700",
                fontSize: "18px",
                textAlign: "left"
              }}
            >
              Subject:
            </td>

            <td style={{ paddingRight: "22px" }}>
              <input
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                placeholder="Subject"
                style={{
                  width: "100%",
                  height: "54px",
                  border: "1px solid #d8d8d8",
                  borderRadius: "8px",
                  padding: "0 16px",
                  fontSize: "18px",
                  outline: "none",
                  boxSizing: "border-box"
                }}
              />
            </td>
          </tr>
        </tbody>
      </table>

      {/* MESSAGE BODY */}
      <div
        style={{
          padding: "20px 22px",
          minHeight: "400px"
        }}
      >
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Write your message..."
          style={{
            width: "100%",
            height: "360px",
            border: "none",
            resize: "none",
            outline: "none",
            fontSize: "18px",
            lineHeight: "1.7",
            color: "#333",
            boxSizing: "border-box"
          }}
        />
      </div>

      {/* FOOTER */}
      <table
        style={{
          width: "100%",
          borderTop: "1px solid #ededed",
          borderCollapse: "collapse"
        }}
      >
        <tbody>
          <tr>
            <td
              style={{
                padding: "18px 22px",
                textAlign: "left",
                fontSize: "22px",
                color: "#555"
              }}
            >
              <span
                style={{
                  marginRight: "18px"
                }}
              >
                <button
                onClick={clearMessageBody}
                style={{
                  background: "#3d5ef1",
                  color: "#fff",
                  border: "none",
                  borderRadius: "10px",
                  width: "120px",
                  height: "46px",
                  fontSize: "15px",
                  fontWeight: "700",
                  cursor: "pointer"
                }}
              >
                Clear Message
              </button>
              </span>
            </td>

            <td
              style={{
                padding: "25px 22px",
                width: "200px",
                textAlign: "right",
                color: "#777",
                fontSize: "14px"
              }}
            >
              {message.length}/2000 <span> characters</span>
            </td>

            <td
              style={{
                padding: "18px 22px",
                width: "150px",
                textAlign: "right"
              }}
            >
              <button
                onClick={sendInmail}
                style={{
                  background: "rgb(7, 165, 147)",
                  color: "#fff",
                  border: "none",
                  borderRadius: "10px",
                  width: "120px",
                  height: "46px",
                  fontSize: "15px",
                  fontWeight: "700",
                  cursor: "pointer"
                }}
              >
                Send
              </button>
            </td>
          </tr>
        </tbody>
      </table>

    </div>
  </div>
)}

            {showPopup && (
                <UserScheduleAppointmentPopup
                    onClose={() => setShowPopup(false)}
                    doctorEmail={doctorDetails?.email}
                    firebase={firebase}
                />
            )}

            <div className="blue-block"></div>

            {
                isLoading
                    ? <ul className="loader doctor-loader">
                        <li><Spinner size={50} /></li>
                    </ul>

                    :

                    <div className="doctor-detailes">

                        <div
                            onClick={() => { history.push('/providers') }}
                            className="top-arrow"
                        >
                            <img src={back_arrow} alt="" />
                            <span>Return to search</span>
                        </div>

                        <div className="detailes-top">

                            <div className="profile-image">
                                {!isImgLoding
                                    ? null
                                    : <div className="headshot-loader">
                                        <Spinner size={35} />
                                    </div>
                                }

                                <img
                                    src={
                                        doctorDetails?.headshotURL
                                            ? doctorDetails.headshotURL
                                            : logo
                                    }
                                    alt="profile"
                                    onLoad={() => setImgLoding(false)}
                                />
                            </div>

                            <div className="right-detailes">

                                <div className="top-data">

                                    <div className="basic-info">
                                        <h3 className="name">
                                            {doctorDetails?.name}
                                        </h3>

                                        <div className="specialties">
                                            {
                                                doctorDetails?.specialties?.map((spec, i) => (
                                                    <span key={i}>{spec}</span>
                                                ))
                                            }
                                        </div>
                                    </div>

                                    <div className="loc-rating">

                                        <div className="location">
                                            <div className="loc">
                                                <img src={loc_img} alt="location" />
                                                <span>{distance}mi</span>
                                            </div>
                                        </div>

                                        {doctorDetails?.averageRating &&
                                            <div className="star-div">
                                                <div className="img">
                                                    <Rating
                                                        emptySymbol={<img src={sm_star} className="icon" />}
                                                        fullSymbol={<img src={full_star} className="icon" />}
                                                        initialRating={doctorDetails?.averageRating}
                                                        readonly
                                                    />
                                                    <span className="rev-count">
                                                        {doctorDetails?.ratingCount}
                                                    </span>
                                                </div>
                                            </div>
                                        }

                                    </div>

                                </div>

                                <div className="contact-info">

                                    <div className="contact-data">
                                        <h3 className="contact-title">
                                            Contact information
                                        </h3>

                                        <div className="group-data">

                                            <div className="info-field">
                                                <div>
                                                    <img src={phone_icon} alt="" />
                                                </div>
                                                <span className="contact-data phone-no">
                                                    {doctorDetails?.phoneNumber}
                                                </span>
                                            </div>

                                            {doctorDetails?.website &&
                                                <div className="info-field">
                                                    <div className="back-shade">
                                                        <img src={glob_icon} alt="" />
                                                    </div>

                                                    <span className="contact-data website">
                                                        <a
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            href={"https://" + doctorDetails?.website}
                                                        >
                                                            {doctorDetails?.website}
                                                        </a>
                                                    </span>
                                                </div>
                                            }

                                            <div className="info-field">
                                                <div className="back-shade">
                                                    <img src={address_icon} alt="" />
                                                </div>

                                                <span className="contact-data address">
                                                    {doctorDetails?.address}
                                                </span>
                                            </div>

                                        </div>
                                    </div>

                                    <div className="schedule">

                                        <div className="timings-container">

                                            <div className="timings-top">
                                                <h3 className="open-text">Open</h3>
                                                <h3>Close in 5:00pm</h3>
                                                <img src={up_arrow} alt="up-arrow" />
                                            </div>

                                            <hr />

                                            <div className="days">

                                                <div className="day">
                                                    <span>Monday</span>
                                                    <span className="time">
                                                        9:00am - 5:00pm
                                                    </span>
                                                </div>

                                                <div className="day">
                                                    <span>Tuesday</span>
                                                    <span className="time">
                                                        9:00am - 5:00pm
                                                    </span>
                                                </div>

                                                <div className="day">
                                                    <span>Wednesday</span>
                                                    <span className="time">
                                                        9:00am - 5:00pm
                                                    </span>
                                                </div>

                                                <div className="day active">
                                                    <span>Thursday</span>
                                                    <span className="time">
                                                        9:00am - 5:00pm
                                                    </span>
                                                </div>

                                                <div className="day">
                                                    <span>Saturday</span>
                                                    <span className="time">
                                                        Weekend
                                                    </span>
                                                </div>

                                                <div className="day">
                                                    <span>Sunday</span>
                                                    <span className="time">
                                                        Weekend
                                                    </span>
                                                </div>

                                                {/* 🔥 NEW BUTTONS */}
                                                <div
                                                    style={{
                                                        marginTop: "12px",
                                                        display: "flex",
                                                        gap: "10px",
                                                        flexWrap: "wrap"
                                                    }}
                                                >

                                                    {showInmailButton && (
                                                        <button
                                                            onClick={() => setShowInmailPopup(true)}
                                                            style={{
                                                                padding: "10px 16px",
                                                                borderRadius: "8px",
                                                                border: "1px solid #0d6efd",
                                                                background: "#fff",
                                                                color: "#0d6efd",
                                                                cursor: "pointer"
                                                            }}
                                                        >
                                                            Send InMail
                                                        </button>
                                                    )}

                                                    {doctorDetails?.subscription &&
                                                        doctorDetails.subscription !== "" && (
                                                            <button
                                                                onClick={() => setShowPopup(true)}
                                                                style={{
                                                                    padding: "10px 16px",
                                                                    borderRadius: "8px",
                                                                    border: "none",
                                                                    background: "#198754",
                                                                    color: "#fff",
                                                                    cursor: "pointer"
                                                                }}
                                                            >
                                                                Schedule Appointment
                                                            </button>
                                                        )
                                                    }

                                                </div>

                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="detailes-bottom">

                            <div className="tabs-container">

                                <span
                                    onClick={() => changeTab("description")}
                                    className={
                                        currentTab === "description"
                                            ? 'active'
                                            : "span"
                                    }
                                >
                                    Description
                                </span>

                                <span
                                    onClick={() => changeTab("review")}
                                    className={
                                        currentTab === "review"
                                            ? 'active'
                                            : "span"
                                    }
                                >
                                    Reviews
                                </span>

                                <span
                                    onClick={() => changeTab("chat")}
                                    className={
                                        currentTab === "chat"
                                            ? 'active'
                                            : "span"
                                    }
                                >
                                    Chat
                                </span>

                            </div>

                            <div className="tab-view">
                                {switchTab(currentTab)}
                            </div>

                        </div>

                    </div>
            }

        </div>
    )
}

export default withFirebase(Doctor)
